import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Button, Table, Form, Badge, Alert, Modal, Spinner, ButtonGroup } from 'react-bootstrap';
import { FaUpload, FaCalendarAlt, FaUniversity, FaFilter } from 'react-icons/fa';
import api from '../services/api';
import '../styles/bankCreditManagement.css';

const AdminBankCreditManagementPage = () => {
    // State
    const [bankCredits, setBankCredits] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    // Filters
    const [filters, setFilters] = useState({
        bankName: '',
        projectNo: '',
        paymentStatus: '',
        startDate: '',
        endDate: '',
        page: 1,
        limit: 20
    });

    // Modals
    const [showUploadModal, setShowUploadModal] = useState(false);
    const [uploadFile, setUploadFile] = useState(null);
    // YENİ: Proje dropdown ve delete modal
    const [availableProjects, setAvailableProjects] = useState([]);
    const [loadingProjects, setLoadingProjects] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteProjectId, setDeleteProjectId] = useState(null);
    const [deletePassword, setDeletePassword] = useState('');
    const [deleteError, setDeleteError] = useState('');

    // MANUAL GİRİŞ STATE'LERİ
    const [showManualModal, setShowManualModal] = useState(false);
    const [manualProject, setManualProject] = useState({
        bankName: '',
        projectNo: '',
        installmentCount: 12,
        firstDate: '',
        installmentAmount: ''
    });
    const [manualInstallments, setManualInstallments] = useState([]);
    // MANUAL PDF UPLOAD STATE
    const [manualFile, setManualFile] = useState(null);
    const [manualFileError, setManualFileError] = useState('');
    const [showPreviewTable, setShowPreviewTable] = useState(false);
    const [editingCell, setEditingCell] = useState(null); // {row: 0, field: 'date'/'amount'}

    // Dashboard Stats
    const [dashboardStats, setDashboardStats] = useState(null);

    // Load data on mount
    useEffect(() => {
        loadBankCredits();
    }, [filters]);


    // Manual taksit tablosu oluştur
    const generateManualInstallments = () => {
        const { installmentCount, firstDate, installmentAmount } = manualProject;
        const installments = [];

        for (let i = 1; i <= installmentCount; i++) {
            const installmentDate = new Date(firstDate);
            installmentDate.setMonth(installmentDate.getMonth() + (i - 1));

            installments.push({
                installmentNo: i,
                installmentDate: installmentDate, // Date object olarak sakla
                installmentAmount: parseFloat(installmentAmount),
                paymentStatus: 'unpaid'
            });
        }

        setManualInstallments(installments);
        setShowPreviewTable(true);
        console.log('📋 Manual installments generated:', installments);
    };

    // Manual projeyi kaydet
    // Manual projeyi kaydet
    const saveManualProject = async () => {
        try {
            // PDF file validation
            if (!manualFile) {
                setManualFileError('PDF dosyası seçimi zorunludur');
                return;
            }

            if (manualFile.type !== 'application/pdf') {
                setManualFileError('Sadece PDF dosyaları yüklenebilir');
                return;
            }

            setLoading(true);
            setManualFileError('');

            // FormData oluştur
            const formData = new FormData();
            formData.append('document', manualFile);
            formData.append('bankName', manualProject.bankName);
            formData.append('projectNo', manualProject.projectNo);
            formData.append('projectTitle', `${manualProject.bankName} - ${manualProject.projectNo}`);
            formData.append('installments', JSON.stringify(manualInstallments.map(inst => ({
                installmentNo: inst.installmentNo,
                installmentDate: inst.installmentDate,
                installmentAmount: inst.installmentAmount,
                paymentStatus: 'unpaid',
                paidDate: null,
                paidAmount: 0,
                paymentNotes: '',
                breakdown: { principal: 0, interest: 0, tax: 0, fee: 0 }
            }))));



            const response = await api.post('/bank-projects/manual', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });

            if (response.data.success) {
                setSuccess('Manual proje ve PDF başarıyla eklendi');
                setShowManualModal(false);
                setShowPreviewTable(false);
                setManualInstallments([]);
                setManualFile(null);
                setManualFileError('');
                setManualProject({
                    bankName: '',
                    projectNo: '',
                    installmentCount: 12,
                    firstDate: '',
                    installmentAmount: ''
                });
                loadBankCredits();

            }

        } catch (error) {
            console.error('❌ Manual project save error:', error);
            setError(error.response?.data?.message || 'Manuel proje kaydedilirken hata oluştu');
        } finally {
            setLoading(false);
        }
    };

    // Load bank credits with filters
    const loadBankCredits = async () => {
        try {
            setLoading(true);

            const params = new URLSearchParams();
            Object.entries(filters).forEach(([key, value]) => {
                if (value) params.append(key, value);
            });

            console.log('🔍 Frontend filters:', filters);
            console.log('🔍 URL params:', params.toString());

            const response = await api.get(`/bank-projects?${params}`);
            console.log('🔍 Frontend response:', response.data);

            // Backend zaten flattened installments gönderiyor
            if (response.data.data) {
                setBankCredits(response.data.data);

                // ✅ YENİ: Stats'ı set et
                if (response.data.stats) {
                    setDashboardStats({
                        totals: response.data.stats
                    });
                }
            } else {
                setBankCredits([]);
            }

        } catch (error) {
            setError('Veriler yüklenirken hata oluştu');
        } finally {
            setLoading(false);
        }
    };

    // Load projects by bank
    const loadProjectsByBank = async (bankName) => {
        if (!bankName) {
            setAvailableProjects([]);
            return;
        }

        try {
            setLoadingProjects(true);
            const response = await api.get(`/bank-projects/by-bank/${bankName}`);

            if (response.data.success) {
                setAvailableProjects(response.data.data || []);
            } else {
                setAvailableProjects([]);
            }
        } catch (error) {
            console.error('Projeler yüklenemedi:', error);
            setAvailableProjects([]);
        } finally {
            setLoadingProjects(false);
        }
    };

    // Load dashboard stats, silindi



    // PDF Upload
    const handlePDFUpload = async () => {
        if (!uploadFile) return;

        const formData = new FormData();
        formData.append('document', uploadFile);
        formData.append('bankName', document.getElementById('uploadBankName').value);
        formData.append('notes', document.getElementById('uploadNotes').value || '');

        try {
            setLoading(true);
            const response = await api.post('/bank-projects/upload-pdf', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });

            setSuccess('PDF başarıyla yüklendi ve işlendi');
            setShowUploadModal(false);
            setUploadFile(null);
            loadBankCredits();

        } catch (error) {
            setError(error.response?.data?.message || 'PDF yükleme hatası');
        } finally {
            setLoading(false);
        }
    };

    // Payment status update
    const updatePaymentStatus = async (projectId, installmentNo, status) => {
        try {
            console.log('🔄 Updating payment:', { projectId, installmentNo, status });

            // Optimistic update - state'i hemen güncelle
            setBankCredits(prevCredits =>
                prevCredits.map(credit =>
                    credit.projectId.toString() === projectId.toString() &&
                        credit.installmentNo === installmentNo
                        ? { ...credit, paymentStatus: status }
                        : credit
                )
            );

            const response = await api.put(`/bank-projects/${projectId}/installments/${installmentNo}/payment`, {
                paymentStatus: status,
                notes: `Status updated to ${status}`
            });

            console.log('✅ Payment update response:', response.data);
            setSuccess('Ödeme durumu güncellendi');


        } catch (error) {
            console.error('❌ Payment update error:', error);
            setError(error.response?.data?.message || 'Ödeme durumu güncellenirken hata oluştu');

            // Hata varsa state'i geri al
            loadBankCredits();
        }
    };


    // Show delete modal instead of direct delete
    const showDeleteConfirm = (projectId) => {
        setDeleteProjectId(projectId);
        setDeletePassword('');
        setDeleteError('');
        setShowDeleteModal(true);
    };

    // Actual delete function with password
    const deleteProject = async () => {
        if (deletePassword !== '123456') {
            setDeleteError('Hatalı şifre! Tekrar deneyin.');
            return;
        }

        try {
            await api.delete(`/bank-projects/${deleteProjectId}`);
            setSuccess('Proje silindi');
            setShowDeleteModal(false);
            loadBankCredits();

        } catch (error) {
            setDeleteError('Proje silinirken hata oluştu');
        }
    };


    // Filter handlers
    const handleFilterChange = (field, value) => {
        console.log('🔍 Filter change:', { field, value });

        setFilters(prev => {
            const newFilters = {
                ...prev,
                [field]: value,
                page: field === 'page' ? value : 1
            };

            // Sadece banka değiştiğinde proje filtresini temizle
            if (field === 'bankName') {
                newFilters.projectNo = '';
            }

            console.log('🔍 New filters state:', newFilters);
            return newFilters;
        });

        // Banka değiştiğinde projeleri yükle
        if (field === 'bankName') {
            loadProjectsByBank(value);
        }
    };

    const clearFilters = () => {
        setFilters({
            bankName: '',
            projectNo: '',
            paymentStatus: '',
            startDate: '',
            endDate: '',
            page: 1,
            limit: 20
        });
    };


    // Excel export handler
    const handleExcelExport = async () => {
        try {
            setLoading(true);

            const params = new URLSearchParams();
            Object.entries(filters).forEach(([key, value]) => {
                if (value && key !== 'page' && key !== 'limit') {
                    params.append(key, value);
                }
            });

            const response = await api.get(`/bank-projects/export-excel?${params}`, {
                responseType: 'blob'
            });

            // Dosya adını oluştur
            let filename = 'BankaTaksitleri';
            if (filters.paymentStatus) {
                const statusMap = { unpaid: 'Odenmedi', paid: 'Odendi', overdue: 'Gecikti' };
                filename = statusMap[filters.paymentStatus];
            }
            if (filters.startDate && filters.endDate) {
                filename += `_${filters.startDate}_${filters.endDate}`;
            }
            if (filters.bankName) {
                filename = `${filters.bankName.replace(/\s+/g, '')}_${filename}`;
            }
            if (!filters.paymentStatus && !filters.startDate && !filters.endDate) {
                filename = 'TumTaksitler';
            }
            filename += '_Rapor.xlsx';

            // Download
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);

            setSuccess(`Excel raporu indirildi: ${filename}`);

        } catch (error) {
            console.error('❌ Excel export hatası:', error);
            setError('Excel dosyası oluşturulurken hata oluştu');
        } finally {
            setLoading(false);
        }
    };

    // Format currency
    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('tr-TR', {
            style: 'currency',
            currency: 'TRY'
        }).format(amount);
    };

    return (
        <div className="credit-management-page">
            <Container fluid>
                {/* Page Header */}
                <Row className="mb-4">
                    <Col md={8}>
                        <h1>🏦 Banka Kredi Yönetimi</h1>
                        <p className="text-muted">Tüm banka kredi taksitlerini görüntüleyin ve yönetin</p>
                    </Col>
                    <Col md={4} className="text-end">
                        <ButtonGroup>
                            <Button variant="primary" onClick={() => setShowUploadModal(true)}>
                                <FaUpload className="me-1" /> PDF Yükle
                            </Button>
                            <Button variant="success" onClick={() => setShowManualModal(true)}>
                                ✏️ Manual Giriş
                            </Button>
                        </ButtonGroup>
                    </Col>
                </Row>

                {/* Alerts */}
                {error && <Alert variant="danger" onClose={() => setError('')} dismissible>{error}</Alert>}
                {success && <Alert variant="success" onClose={() => setSuccess('')} dismissible>{success}</Alert>}

                {/* Dashboard Stats */}
                {dashboardStats && (
                    <Row className="mb-4">
                        <Col md={6}>
                            <Card className="text-center">
                                <Card.Body>
                                    <h3>{formatCurrency(dashboardStats.totals.totalAmount)}</h3>
                                    <small>Toplam Tutar</small>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={6}>
                            <Card className="text-center">
                                <Card.Body>
                                    <h3>{dashboardStats.totals?.totalInstallments || 0}</h3>
                                    <small>Toplam Taksit</small>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                )}

                {/* Filters */}
                <Card className="mb-4">
                    <Card.Header>
                        <FaFilter className="me-2" />Filtreler
                    </Card.Header>
                    <Card.Body>
                        <Row>
                            <Col md={2}>
                                <Form.Select
                                    value={filters.bankName}
                                    onChange={(e) => handleFilterChange('bankName', e.target.value)}
                                >
                                    <option value="">Tüm Bankalar</option>
                                    <option value="KuveytTürk">KuveytTürk</option>
                                    <option value="Ziraat Katılım">Ziraat Katılım</option>
                                </Form.Select>
                            </Col>
                            <Col md={2}>
                                <Form.Select
                                    value={filters.projectNo}
                                    onChange={(e) => handleFilterChange('projectNo', e.target.value)}
                                    disabled={!filters.bankName || loadingProjects}
                                >
                                    <option value="">
                                        {!filters.bankName ? 'Önce banka seçin' :
                                            loadingProjects ? 'Yükleniyor...' : 'Tüm Projeler'}
                                    </option>
                                    {availableProjects.map(project => (
                                        <option key={project._id} value={project.projectNo}>
                                            {project.projectNo} - {project.projectTitle || 'Proje'}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Col>
                            <Col md={2}>
                                <Form.Select
                                    value={filters.paymentStatus}
                                    onChange={(e) => handleFilterChange('paymentStatus', e.target.value)}
                                >
                                    <option value="">Tüm Durumlar</option>
                                    <option value="unpaid">Ödenmedi</option>
                                    <option value="paid">Ödendi</option>
                                    <option value="overdue">Gecikti</option>
                                </Form.Select>
                            </Col>
                            <Col md={2}>
                                <Form.Control
                                    type="date"
                                    value={filters.startDate}
                                    onChange={(e) => handleFilterChange('startDate', e.target.value)}
                                />
                            </Col>
                            <Col md={2}>
                                <Form.Control
                                    type="date"
                                    value={filters.endDate}
                                    onChange={(e) => handleFilterChange('endDate', e.target.value)}
                                />
                            </Col>
                            <Col md={2}>
                                <Button
                                    variant="dark"
                                    onClick={clearFilters}
                                    className="w-100"
                                    style={{ height: '38px' }}
                                >
                                    Temizle
                                </Button>
                            </Col>
                        </Row>
                        {/* Excel Export Butonu - İkinci Satır */}
                        <Row className="mt-3">
                            <Col md={12} className="d-flex justify-content-end">
                                <Button
                                    variant="success"
                                    onClick={handleExcelExport}
                                    disabled={loading}
                                    style={{ minWidth: '200px' }}
                                >
                                    📊 Excel'e Aktar
                                </Button>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>

                {/* Data Table */}
                <Card>
                    <Card.Header>
                        <h5>Kredi Taksitleri</h5>
                    </Card.Header>
                    <Card.Body>
                        {loading ? (
                            <div className="text-center">
                                <Spinner animation="border" />
                                <p>Yükleniyor...</p>
                            </div>
                        ) : (
                            <Table responsive striped hover>
                                <thead>
                                    <tr>
                                        <th>Banka</th>
                                        <th>Proje No</th>
                                        <th>Taksit</th>
                                        <th>Tarih</th>
                                        <th>Tutar</th>
                                        <th>Durum</th>
                                        <th>İşlemler</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {bankCredits.map(credit => (
                                        <tr key={credit._id}>
                                            <td>
                                                <FaUniversity className="me-1" />
                                                {credit.bankName}
                                            </td>
                                            <td>{credit.projectNo}</td>
                                            <td>
                                                {credit.installmentNo}/{credit.totalInstallments}
                                            </td>
                                            <td>
                                                <FaCalendarAlt className="me-1" />
                                                {new Date(credit.installmentDate).toLocaleDateString('tr-TR')}
                                            </td>
                                            <td>{formatCurrency(credit.installmentAmount)}</td>
                                            <td>
                                                <Form.Select
                                                    size="sm"
                                                    value={credit.paymentStatus}
                                                    onChange={(e) => updatePaymentStatus(credit.projectId, credit.installmentNo, e.target.value)}
                                                    style={{
                                                        backgroundColor:
                                                            credit.paymentStatus === 'paid' ? '#d4edda' :
                                                                credit.paymentStatus === 'overdue' ? '#f8d7da' : '#ffeaa7',
                                                        color:
                                                            credit.paymentStatus === 'paid' ? '#155724' :
                                                                credit.paymentStatus === 'overdue' ? '#721c24' : '#856404',
                                                        border: 'none'
                                                    }}
                                                >
                                                    <option value="unpaid">Ödenmedi</option>
                                                    <option value="paid">Ödendi</option>
                                                    <option value="overdue">Gecikti</option>
                                                </Form.Select>
                                            </td>
                                            <td>
                                                {credit.installmentNo === 1 ? (
                                                    <div className="d-flex gap-1">
                                                        <Button
                                                            variant="outline-primary"
                                                            size="sm"
                                                            onClick={() => {
                                                                // Direct backend call with auth headers
                                                                window.open(`${api.defaults.baseURL}/bank-projects/${credit.projectId}/pdf?token=${localStorage.getItem('token')}`, '_blank');
                                                            }}
                                                            title="PDF görüntüle"
                                                        >
                                                            📄
                                                        </Button>
                                                        <Button
                                                            variant="outline-danger"
                                                            size="sm"
                                                            onClick={() => showDeleteConfirm(credit.projectId)}
                                                            title="Projeyi sil"
                                                        >
                                                            🗑️
                                                        </Button>
                                                    </div>
                                                ) : (
                                                    <span>-</span>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        )}

                        {/* Pagination */}
                        {bankCredits.length > 0 && (
                            <div className="d-flex justify-content-between align-items-center mt-3">
                                <small className="text-muted">
                                    Gösterilen: {bankCredits.length} taksit
                                </small>
                                <div className="d-flex align-items-center gap-2">
                                    <Button
                                        variant="outline-secondary"
                                        size="sm"
                                        onClick={() => handleFilterChange('page', Math.max(filters.page - 1, 1))}
                                        disabled={filters.page <= 1}
                                    >
                                        « Önceki
                                    </Button>
                                    <Form.Select
                                        size="sm"
                                        value={filters.page}
                                        onChange={(e) => handleFilterChange('page', parseInt(e.target.value))}
                                        style={{ width: 'auto', minWidth: '140px' }}
                                    >
                                        {dashboardStats && Array.from({ length: Math.ceil(dashboardStats.totals.totalInstallments / filters.limit) || 1 }, (_, i) => i + 1).map(pageNum => (
                                            <option key={pageNum} value={pageNum}>
                                                Sayfa {pageNum}/{Math.ceil(dashboardStats.totals.totalInstallments / filters.limit) || 1}
                                            </option>
                                        ))}
                                    </Form.Select>
                                    <Button
                                        variant="outline-secondary"
                                        size="sm"
                                        onClick={() => handleFilterChange('page', filters.page + 1)}
                                        disabled={bankCredits.length < filters.limit}
                                    >
                                        Sonraki »
                                    </Button>
                                </div>
                            </div>
                        )}
                    </Card.Body>
                </Card>

                {/* PDF Upload Modal */}
                <Modal show={showUploadModal} onHide={() => setShowUploadModal(false)} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>PDF Yükle ve İşle</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Form.Group className="mb-3">
                                <Form.Label>Banka Seçin</Form.Label>
                                <Form.Select id="uploadBankName" required>
                                    <option value="">Banka Seçin</option>
                                    <option value="KuveytTürk">KuveytTürk</option>
                                    <option value="Ziraat Katılım">Ziraat Katılım</option>
                                </Form.Select>
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>PDF Dosyası</Form.Label>
                                <Form.Control
                                    type="file"
                                    accept=".pdf"
                                    onChange={(e) => setUploadFile(e.target.files[0])}
                                    required
                                />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>Notlar (Opsiyonel)</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    id="uploadNotes"
                                    placeholder="Ek notlar..."
                                />
                            </Form.Group>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowUploadModal(false)}>
                            İptal
                        </Button>
                        <Button
                            variant="primary"
                            onClick={handlePDFUpload}
                            disabled={!uploadFile || loading}
                        >
                            {loading ? <Spinner animation="border" size="sm" /> : 'Yükle ve İşle'}
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Delete Confirmation Modal */}
                <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>🗑️ Proje Silme Onayı</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Alert variant="danger">
                            <strong>⚠️ Dikkat!</strong> Bu işlem geri alınamaz.
                        </Alert>

                        <p>Bu projeyi silmek için şifrenizi girin:</p>

                        <Form.Group className="mb-3">
                            <Form.Label>Silme Şifresi</Form.Label>
                            <Form.Control
                                type="password"
                                placeholder="Şifrenizi girin"
                                value={deletePassword}
                                onChange={(e) => setDeletePassword(e.target.value)}
                                isInvalid={!!deleteError}
                            />
                            <Form.Control.Feedback type="invalid">
                                {deleteError}
                            </Form.Control.Feedback>
                        </Form.Group>

                        <small className="text-muted">
                            💡 İpucu: Silme şifresi <code>123456</code>
                        </small>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
                            İptal
                        </Button>
                        <Button
                            variant="danger"
                            onClick={deleteProject}
                            disabled={!deletePassword}
                        >
                            🗑️ Proje Sil
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Manual Giriş Modal */}
                <Modal show={showManualModal} onHide={() => setShowManualModal(false)} size="xl" centered>
                    <Modal.Header closeButton>
                        <Modal.Title>✏️ Manual Proje Girişi</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {!showPreviewTable ? (
                            // FORM AŞAMASI
                            <Form>
                                <Row>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Banka Seçin *</Form.Label>
                                            <Form.Select
                                                value={manualProject.bankName}
                                                onChange={(e) => setManualProject(prev => ({ ...prev, bankName: e.target.value }))}
                                                required
                                            >
                                                <option value="">Banka Seçin</option>
                                                <option value="KuveytTürk">KuveytTürk</option>
                                                <option value="Ziraat Katılım">Ziraat Katılım</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Proje No *</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Proje numarasını girin"
                                                value={manualProject.projectNo}
                                                onChange={(e) => setManualProject(prev => ({ ...prev, projectNo: e.target.value }))}
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>PDF Dosyası *</Form.Label>
                                            <Form.Control
                                                type="file"
                                                accept=".pdf"
                                                onChange={(e) => {
                                                    setManualFile(e.target.files[0]);
                                                    setManualFileError('');
                                                }}
                                                isInvalid={!!manualFileError}
                                                required
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {manualFileError}
                                            </Form.Control.Feedback>
                                            <Form.Text className="text-muted">
                                                📄 Formatsız PDF dosyasını yükleyiniz (Manuel giriş için)
                                            </Form.Text>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Vade Sayısı *</Form.Label>
                                            <Form.Control
                                                type="number"
                                                min="1"
                                                max="120"
                                                value={manualProject.installmentCount}
                                                onChange={(e) => setManualProject(prev => ({ ...prev, installmentCount: parseInt(e.target.value) || 1 }))}
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>İlk Taksit Tarihi *</Form.Label>
                                            <Form.Control
                                                type="date"
                                                value={manualProject.firstDate}
                                                onChange={(e) => setManualProject(prev => ({ ...prev, firstDate: e.target.value }))}
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Taksit Miktarı (₺) *</Form.Label>
                                            <Form.Control
                                                type="number"
                                                step="0.01"
                                                min="0"
                                                placeholder="0.00"
                                                value={manualProject.installmentAmount}
                                                onChange={(e) => setManualProject(prev => ({ ...prev, installmentAmount: e.target.value }))}
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Form>
                        ) : (
                            // PREVIEW TABLE AŞAMASI 
                            // PREVIEW TABLE AŞAMASI
                            <div>
                                <Alert variant="info" className="mb-3">
                                    <strong>📋 Taksit Tablosu Önizlemesi</strong><br />
                                    Tarihleri ve miktarları düzenlemek için üzerine tıklayın.
                                </Alert>

                                <Table responsive striped hover size="sm">
                                    <thead>
                                        <tr>
                                            <th>Banka</th>
                                            <th>Proje No</th>
                                            <th>Taksit</th>
                                            <th>Tarih</th>
                                            <th>Tutar</th>
                                            <th>Durum</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {manualInstallments.map((installment, index) => (
                                            <tr key={index}>
                                                <td>{manualProject.bankName}</td>
                                                <td>{manualProject.projectNo}</td>
                                                <td>{installment.installmentNo}/{manualProject.installmentCount}</td>
                                                <td
                                                    onClick={() => setEditingCell({ row: index, field: 'date' })}
                                                    style={{ cursor: 'pointer', backgroundColor: editingCell?.row === index && editingCell?.field === 'date' ? '#e3f2fd' : 'transparent' }}
                                                >
                                                    {editingCell?.row === index && editingCell?.field === 'date' ? (
                                                        <Form.Control
                                                            type="date"
                                                            size="sm"
                                                            value={installment.installmentDate.toISOString().split('T')[0]}
                                                            onChange={(e) => {
                                                                const newInstallments = [...manualInstallments];
                                                                newInstallments[index].installmentDate = new Date(e.target.value);
                                                                setManualInstallments(newInstallments);
                                                            }}
                                                            onBlur={() => setEditingCell(null)}
                                                            autoFocus
                                                        />
                                                    ) : (
                                                        installment.installmentDate.toLocaleDateString('tr-TR')
                                                    )}
                                                </td>
                                                <td
                                                    onClick={() => setEditingCell({ row: index, field: 'amount' })}
                                                    style={{ cursor: 'pointer', backgroundColor: editingCell?.row === index && editingCell?.field === 'amount' ? '#e3f2fd' : 'transparent' }}
                                                >
                                                    {editingCell?.row === index && editingCell?.field === 'amount' ? (
                                                        <Form.Control
                                                            type="number"
                                                            size="sm"
                                                            step="0.01"
                                                            value={installment.installmentAmount}
                                                            onChange={(e) => {
                                                                const newInstallments = [...manualInstallments];
                                                                newInstallments[index].installmentAmount = parseFloat(e.target.value) || 0;
                                                                setManualInstallments(newInstallments);
                                                            }}
                                                            onBlur={() => setEditingCell(null)}
                                                            autoFocus
                                                        />
                                                    ) : (
                                                        formatCurrency(installment.installmentAmount)
                                                    )}
                                                </td>
                                                <td>
                                                    <Badge bg="warning">Ödenmedi</Badge>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </div>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => {
                            setShowManualModal(false);
                            setShowPreviewTable(false);
                            setManualInstallments([]);
                        }}>
                            İptal
                        </Button>
                        {!showPreviewTable ? (
                            <Button
                                variant="primary"
                                onClick={generateManualInstallments}
                                disabled={!manualProject.bankName || !manualProject.projectNo || !manualProject.firstDate || !manualProject.installmentAmount}
                            >
                                📋 Taksit Tablosu Oluştur
                            </Button>
                        ) : (
                            <Button
                                variant="success"
                                onClick={saveManualProject}
                                disabled={loading}
                            >
                                {loading ? <Spinner animation="border" size="sm" /> : '✅ Tama Ekle'}
                            </Button>
                        )}
                    </Modal.Footer>
                </Modal>

            </Container>
        </div>
    );
};

export default AdminBankCreditManagementPage;